// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ERR_REQ_PROVIDER_SVC, SUC_REQ_PROVIDER_SVC } from '../../../../utils/strings';

export const useRequestProviderService = () => {
  const { submit } = useCreateSubmission(
    ProviderServiceRequest,
    SUC_REQ_PROVIDER_SVC,
    ERR_REQ_PROVIDER_SVC,
  );
  return submit;
};
